import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  addPendingRedirect,
  ENavPages,
  IPendingRedirectActionParams,
  navConfig,
  portalRedirect
} from '../internal';

interface IProps {
  history: any,
  addPendingRedirect(redirOpts: IPendingRedirectActionParams): void,
}

class ForwardToAccountDetailsContainer extends Component<IProps> {
  constructor(props: IProps) {
    super(props);

  }

  componentDidMount() {
    this.props.addPendingRedirect({ pathname: navConfig.get(ENavPages.myProfile)!.linkTo() });
  }

  render() {
    return (
      <>
      </>
    )
  }
}

function mapStateToProps(state: any) {
  return {

  }
}

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  addPendingRedirect
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ForwardToAccountDetailsContainer)
